import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useLang } from "../../context/LangContext";
import ProductCard from "../../components/ProductCard";
import SubPageShell from "../../components/SubPageShell";

const WISH_KEY = "simashi_wish";
const readWish = () => {
  try { return JSON.parse(localStorage.getItem(WISH_KEY) || "[]"); } catch { return []; }
};

export default function Favorites() {
  const { t } = useLang();
  const [items, setItems] = useState(null);

  useEffect(() => {
    const ids = readWish();
    if (!ids.length) { setItems([]); return; }
    Promise.all(ids.map((id) => api(`/products/${id}`).catch(() => null))).then((r) =>
      setItems(r.filter(Boolean))
    );
  }, []);

  return (
    <SubPageShell title={t("favorite")} tid="favorites-page">
      {items === null ? (
        <p data-testid="favorites-loading" className="py-10 text-center text-sm text-slate-500">...</p>
      ) : items.length === 0 ? (
        <div data-testid="favorites-empty" className="mt-6 rounded-2xl border border-dashed border-slate-300 py-12 text-center">
          <p className="font-heading font-semibold text-slate-800">{t("no_fav")}</p>
          <p className="mt-1 text-sm text-slate-500">{t("no_fav_sub")}</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {items.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </SubPageShell>
  );
}
